import { render, staticRenderFns } from "./AgmAffirm.vue?vue&type=template&id=1597f6ca&scoped=true&"
import script from "./AgmAffirm.vue?vue&type=script&lang=js&"
export * from "./AgmAffirm.vue?vue&type=script&lang=js&"
import style0 from "./AgmAffirm.vue?vue&type=style&index=0&id=1597f6ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597f6ca",
  null
  
)

export default component.exports